import { render, staticRenderFns } from "./SoccerJoinMain.vue?vue&type=template&id=00787c57&scoped=true&"
import script from "./SoccerJoinMain.vue?vue&type=script&lang=js&"
export * from "./SoccerJoinMain.vue?vue&type=script&lang=js&"
import style0 from "./SoccerJoinMain.vue?vue&type=style&index=0&id=00787c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00787c57",
  null
  
)

export default component.exports